import { pxToEm } from 'util/pxToEm';
import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

export interface AboutTabProps {
  organizationName: string;
  schoolName?: string;
  numEvents?: { pending: number; live: number; past: number };
}

const Row = ({ label, value }: { label: string; value: string }): ReactElement => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
    <Typography
      sx={{
        fontFamily: 'Poppins',
        fontWeight: 600,
        fontSize: pxToEm(12),
        letterSpacing: '0.25px',
        textTransform: 'uppercase',
        color: '#6B6B6B',
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontSize: pxToEm(14),
        color: '#383838',
        lineHeight: 1.5,
      }}
    >
      {value}
    </Typography>
  </Box>
);

export const AboutTab = ({
  organizationName,
  schoolName,
  numEvents,
}: AboutTabProps): ReactElement => {
  const totalEvents = numEvents
    ? numEvents.pending + numEvents.live + numEvents.past
    : null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Row label="Organization" value={organizationName} />
      {schoolName && <Row label="School" value={schoolName} />}
      {totalEvents !== null && (
        <Row
          label="Events Hosted"
          value={`${totalEvents} total • ${numEvents?.live ?? 0} upcoming`}
        />
      )}
    </Box>
  );
};
